// Which resident a journal entry opens, and how. A resident still in this
// tank opens its card; one that has left opens its record. A fish moved
// out when its quarantine finished lives in another tank now, so neither
// this tank's residents nor its history list it: the owner's own history
// (every tank they keep) still does, and it opens as a record there.
// `get` is api() from api.js, passed in so this stays testable.
export async function locateJournalResident(tank, livestockId, get) {
  const live = (tank?.livestock || []).find((r) => r.id === livestockId);
  if (live) return { row: live, view: 'card' };
  const rows = await get(`/api/tanks/${tank.id}/livestock/history`);
  const here = (rows || []).find((r) => r.id === livestockId);
  if (here) return { row: here, view: here.status !== 'in_tank' ? 'record' : 'card' };
  if (tank.role !== 'owner') return null;
  const mine = await get('/api/livestock/history');
  const moved = (mine || []).find((r) => r.id === livestockId);
  return moved ? { row: moved, view: 'record' } : null;
}
